<template>
    <div class="my-account-password-modify-box">
        <ul>
            <li>
                <p class="my-account-password-modify-title">手机号</p>
                <input type="number" class="my-account-password-modify-input" v-model="formData.phoneNumber"
                    placeholder="请输入手机号" />
            </li>
            <li>
                <p class="my-account-password-modify-title">验证码</p>
                <input type="number" class="my-account-password-modify-input" v-model="formData.code"
                    placeholder="请输入验证码" />
            </li>
            <li>
                <p class="my-account-password-modify-title">新密码</p>
                <input type="text" class="my-account-password-modify-input" v-model="formData.password"
                    placeholder="请输入新密码" />
            </li>
            <li>
                <p class="my-account-password-modify-title">确认密码</p>
                <input type="text" class="my-account-password-modify-input" v-model="confirmPassword"
                    placeholder="请再次输入密码" />
            </li>
            <div class="my-account-password-modify-btn" @click="clickSaveBtnHandler()">
                <p class="my-account-password-modify-btn-text">保存</p>
            </div>
            <div class="my-account-password-modify-verification-code" :class="{ 'is-counting': countingDown }" @click="clickGetCodeHandler()">
                <p class="my-account-password-modify-verification-code-text">{{ buttonText }}</p>
            </div>
        </ul>

    </div>
</template>

<script>
import { resetAccountPassword, resetAccountPasswordSendSms } from '@/services/user';
export default {
    name: "MyAccountPasswordModify",
    data() {
        return {
            formData: {
                phoneNumber: '',
                code: '',
                password: ''
            },
            confirmPassword: '',
            countingDown: false, // 是否正在倒计时
            countdown: 60, // 倒计时秒数
            timer: null, // 存储定时器ID
            buttonText: '获取验证码' // 按钮显示的文本
        }
    },
    methods: {
        //点击保存按钮操作
        async clickSaveBtnHandler() {
            if (!(/^1[3456789]\d{9}$/.test(this.formData.phoneNumber) && /^\d{6}$/.test(this.formData.code))) {
                this.$message.warning('请输入正确的信息');
                return;
            }
            if (this.formData.password.trim().length < 8) {
                this.$message.warning('密码长度至少8位');
                return;
            }
            if (this.confirmPassword !== this.formData.password) {
                this.$message.warning('两次输入的密码不一致');
                return;
            } 
            try {
                const { data } = await resetAccountPassword(this.formData);
                if (data.code == 200) {
                    this.stopCountdown();
                    this.$message.success('设置新密码成功！');
                    this.formData.phoneNumber = '';
                    this.formData.code = '';
                    this.formData.password = '';
                    this.confirmPassword = '';
                }else{
                    this.stopCountdown();
                    this.$message.success('设置新密码失败！');
                }
            } catch (err) {
                this.stopCountdown();
                this.$message.success('设置新密码失败！');
             }
        },
        //点击获取验证码操作
        async clickGetCodeHandler() {
            if (this.countingDown) {
                // 如果正在倒计时，则不允许再次点击
                return;
            }
            this.startCountdown(); // 启动倒计时
            try {
                const { data } = await resetAccountPasswordSendSms(this.formData.phoneNumber);
                if (data.code == 200) {
                    //console.log('短信发送成功===');
                }else if(data.code==7){
                    this.stopCountdown();
                    this.$message.warning('短信验证码错误！');
                }else{
                    this.stopCountdown();
                    this.$message.warning('获取验证码失败，请重试！');
                }
            } catch (err) { 
                this.stopCountdown(); 
                this.$message.warning('获取验证码失败！');
            }
        },
        // 启动倒计时
        startCountdown() {
            if (this.countingDown) return; // 如果已经在倒计时，则不重复启动

            this.countingDown = true;
            this.countdown = 60; // 重置倒计时秒数
            this.buttonText = `${this.countdown}秒后重试`;

            this.timer = setInterval(() => {
                this.countdown--;
                if (this.countdown > 0) {
                    this.buttonText = `${this.countdown}秒后重试`;
                } else {
                    this.stopCountdown();
                }
            }, 1000);
        },

        // 停止倒计时
        stopCountdown() {
            clearInterval(this.timer);
            this.timer = null;
            this.countingDown = false;
            this.buttonText = '获取验证码';
        },
    },
    beforeDestroy(){
        // 组件销毁前清除定时器，防止内存泄漏
        this.stopCountdown();
    }
}
</script>

<style lang="less" scoped>
.my-account-password-modify-box {
    margin-top: 20px;
    width: 1200px;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    ul {
        width: 550px;
        display: flex;
        flex-direction: column;
        align-items: center;
        list-style-type: none;
        padding: 0px;
        position: relative;

        li {
            width: 420px;
            height: 70px;
            list-style: none;
            margin-bottom: 30px;

            .my-account-password-modify-title {
                height: 14px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #555555;
                line-height: 14px;
                text-align: left;
                font-style: normal;
            }

            .my-account-password-modify-input {
                margin-top: 10px;
                width: 420px;
                height: 46px;
                background: #FFFFFF;
                border-radius: 8px;
                border: 1px solid #F0F0F0;
                padding-left: 14px;
                outline: none;

                &::placeholder {
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #CCCCCC;
                    line-height: 14px;
                    text-align: left;
                    font-style: normal;
                }

                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                }
            }

            &:nth-child(2) .my-account-password-modify-input {
                width: 290px;
            }
        }

        .my-account-password-modify-btn {
            width: 200px;
            height: 46px;
            background: #F02233;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: default;

            .my-account-password-modify-btn-text {
                height: 14px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 14px;
                text-align: right;
                font-style: normal;
            }
        }

        .my-account-password-modify-verification-code {
            position: absolute;
            left: 365px;
            top: 124px;
            width: 120px;
            height: 46px;
            background: #F6F7FF;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: default;

            .my-account-password-modify-verification-code-text {
                height: 14px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 14px;
                color: #F02233;
                line-height: 14px;
                text-align: right;
                font-style: normal;
            }
            &.is-counting {
                background: #E0E0E0;
                cursor: not-allowed;

                .my-account-password-modify-verification-code-text {
                color: #999999; 
                }
            }
            &:not(.is-counting):hover {
                background: darken(#F6F7FF, 5%);
            }
        }
    }

}
</style>